<div class="pdf-container">
  <div class="pdf-header">
    <mat-icon class="close-button" (click)="closeModal()">close</mat-icon>
    <h1 class="pdf-header-title">VIEW PDF</h1>
    <h2 class="pdf-header-subtitle">{{ data.title }}</h2>
  </div>
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner></mat-spinner>
    <p>Rendering PDF... Please wait</p>
  </div>
  <ngx-extended-pdf-viewer
    *ngIf="!isLoading"
    class="pdf-viewer"
    [textLayer]="true"
    useBrowserLocale="true"
    [showHandToolButton]="true"
    [src]="pdf"
    [page]="page"
    (pdfLoaded)="onPdfLoaded()">
  </ngx-extended-pdf-viewer>
  <mat-dialog-actions class="pdf-actions">
    <button mat-raised-button color="primary" (click)="openPDF()">Open PDF</button>
  </mat-dialog-actions>
</div>
